/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Thu May 05 2022
*  File : autoloader-dev.ts.ts
*******************************************/

import { config } from "../../../../fanpage/it/lib/config/production.js";
import { FanpageAutoloader } from "../../../../fanpage/it/lib/modules/Autoloader.js";

const al = new FanpageAutoloader(window, config, document.body);
window['getPushNotificationHelper'] = () => al.getPushHelper();
al.startSdkClient()

